import { lazy } from 'react';

import { authRoles } from 'app/auth';

const ClinicReimbursementGuide = lazy(
  () => import('./clinic-reimbursement/ClinicReimbursementGuide')
);

// In-app guides and FAQs that used to live on the public website. Add a route
// per guide here and build the page from the components in ./components.
const GuidesConfig = {
  settings: {
    layout: {
      config: {
        footer: { display: false },
        healtheraHeader: {
          display: true,
          options: { organisationSelector: false, pharmacySelector: false },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [{ path: 'guides/clinic-reimbursement', element: <ClinicReimbursementGuide /> }],
};

export default GuidesConfig;
